export const settings = {
  title_site: 'LMS Demo'
};
